<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-14 23:08:52
 * @LastEditTime: 2025-04-16 23:36:31
-->
<template>
    <div class="login">
        <div class="page_body" v-if="!isshow">
            <div style="font-size: 14px;line-height: 30px;color:#999;">为了给您提供更好的服务，请点击下方授权登陆。</div>
            <div style="font-size: 14px;line-height: 30px;color:#999;margin-top: 10px;">
                我们将会严格遵守《用户隐私保护协议》，我们只会获取头像昵称，仅用于区分用户。</div>
            <van-button round block type="danger" @click="ontextpage" style="margin-top: 50px;">授权登陆</van-button>

        </div>
        <div v-else>
            <div style="width: 100%;text-align: center;padding-top: 40px;">
                <van-icon size="80" name="sign" color="#07c160" />

            </div>
            <div
                style="width: 90%;text-align: center;padding-top: 40px;color: #07c160; font-size: 20px;margin: 0 auto;">
                授权成功，请联系班主任填写信息吧！
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue';
import { Empty } from 'vant';

Vue.use(Empty);
import { login } from "@/api/xicaiquan";
import tools from "@/libs/utils";
import router from "../router";
export default {
    name: "login",
    data() {
        return {
            username: "",
            password: "",
            loading: false,
            isshow: false,
            prevPath: '',
        };
    },
    created() {
        // const prevPath = this.$route.query.from || document.referrer;
        console.log(this.$store.state.prevRoute, '-fomr----')
        this.isshow = this.$route.query.jiause2
    },
    components: {},
    watch: {},
    methods: {
        async login(data) {
            this.loading = true;
            const res = await login(data);
            this.loading = false;
            console.log(res);
            if (res.code == 200) {
                tools.setToken1(res.data.tokenValue);
                // this.$router.push('/tool')
                this.$router.replace({ path: '/tool' });

            }
        },
        ontextpage() {
            console.log(this.$route.query, '------')

            // this.$router.push({
            //   path:'/resetPassword'
            this.getotken()
            // console.log(this.$store.state,'---')
            // })
        },
        getotken() {
            // clearTimeout(iTime);
            // iTime = setTimeout(() => {
            tools.removeToken("token");
            tools.removeToken("userInfo");
            // var myurl=``
            let appId = this.$store.state.APPID;
            console.log(this.$route.query.projectId, '------')
            // console.log(location.href.replace('?jiause2=0',''),)
            // console.log(window.location.pathname,'===')
            // return
            axios
                .post(`/login/getWechatLoginData`, {
                    appId: appId,
                    projectId: this.$route.query.projectId,
                    locationHref: this.$route.query.login ?this.$store.state.prevRoute :location.href + "&jiause2=0" ,
                    // ${location.href}&jiause2=0:"
                })
                .then((res) => {
                    console.log(res, "---");
                    // return
                    // let myurl=urlencode(`${URL}/api/login/wechatAuth?data=${Base64.encode(location.href)}`)
                    tools.setToken(res.data.data.token);
                    if (tools.getToken() != "") {
                        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${res.data.data.redirectUri}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`;
                    }
                });
            console.log("调用啦");
            // }, 250);
        },
        onSubmit(values) {
            this.login(values);
            console.log("submit", values);
        },
    },
};
</script>
<style scoped lang="scss">
h1 {
    text-align: center;
    margin: 30px auto;
}

.page_body {
    width: 80%;
    margin: 0 auto;
    margin-top: 100px;

    >div {
        text-align: center;
    }
}

.login {
    height: 100vh;
    background: #fff;
    overflow: hidden;
}

.form-block {
    width: 90%;
    margin: 0px auto;

    /deep/ .form-item {
        margin: 20px 0px;
        background: #e8eef1;
        border-radius: 10px;
    }
}

.text {
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    color: #1989fa;
}
</style>
